import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex-col gap-2"
}
const _hoisted_2 = { class: "justify-between flex-1 flex items-center" }
const _hoisted_3 = ["disabled"]
const _hoisted_4 = {
  key: 1,
  class: "flex items-center justify-center h-[400px]"
}

import { computed, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import LoadingSpinner from "shared/components/loading_state/LoadingSpinner.vue";
import Modal from "shared/components/modals/Modal.vue";
import { useHierarchyTags } from "shared/composables/hierarchyTags";
import { useConfirmationModal, useConfirmationModalIsOpen } from "shared/composables/toast";
import { useTrackEvent } from "shared/composables/tracking";
import MainButton from "@/components/other/MainButton.vue";
import { useDeleteReport, useUpdateReport } from "@/composables/report";
import { Report, ReportToCreateOrUpdate } from "@/types/Report";
import ReportFormWithPlot from "@/views/reports/components/ReportFormWithPlot.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'EditReportModal',
  props: {
    report: {}
  },
  emits: ["close", "done"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

const { t } = useI18n();

const trackEvent = useTrackEvent();
const { hierarchyTags, isLoading: areHierarchyTagsLoading } = useHierarchyTags();
const { updateReport, isLoading: isReportUpdating } = useUpdateReport();
const { deleteReport, isLoading: isDeleteReportLoading } = useDeleteReport();

const showConfirmationModal = useConfirmationModal();
const isConfirmationModalOpen = useConfirmationModalIsOpen();

const editedReport = ref<Report>({ ...props.report });

const isLoading = computed(() => areHierarchyTagsLoading.value);

const handleReportChange = (change: Partial<Report>) => {
  editedReport.value = { ...editedReport.value, ...change };
};

const handleClose = () => {
  if (isConfirmationModalOpen.value) {
    return;
  }
  emit("close");
};

const handleUpdateClick = () => {
  if (isReportUpdating.value) {
    return;
  }
  const reportToUpdate: ReportToCreateOrUpdate = {
    _id: editedReport.value._id,
    type: editedReport.value.type,
    name: editedReport.value.name || props.report.name,
    filters: editedReport.value.filters,
    config: editedReport.value.config,
    aggregation: editedReport.value.aggregation,
  };
  updateReport(reportToUpdate)
    .then((updatedReport) => {
      emit("done", updatedReport);
    })
    .catch(() => undefined);
};

const handleDeleteReportClick = () => {
  if (!editedReport.value || isDeleteReportLoading.value) {
    return;
  }
  const reportId = editedReport.value._id;
  showConfirmationModal({
    confirmAction: t("analytics.reports.delete_confirmation.confirm"),
    cancelAction: t("analytics.reports.delete_confirmation.cancel"),
    message: t("analytics.reports.delete_confirmation.message", {
      name: editedReport.value.name,
    }),
    header: t("analytics.reports.delete_confirmation.header"),
  }).then((confirmed) => {
    if (confirmed) {
      trackEvent("dashboard_widget_report_delete", { type: editedReport?.value?.type });
      deleteReport(reportId).catch(() => undefined);
    }
  });
};

watch(
  () => props.report,
  () => {
    editedReport.value = { ...props.report };
  },
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    open: true,
    onClose: handleClose,
    customCls: "w-full lg:w-2/3 m-2"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", null, [
        (!isLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createVNode(ReportFormWithPlot, {
                hierarchyTags: _unref(hierarchyTags),
                report: editedReport.value,
                onChange: handleReportChange
              }, null, 8, ["hierarchyTags", "report"]),
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("button", {
                  onClick: handleDeleteReportClick,
                  type: "button",
                  disabled: _unref(isDeleteReportLoading),
                  class: "flex items-center justify-center rounded-md px-4 py-2 md:text-sm text-xs shadow-sm bg-red-400 text-white disabled:bg-gray-300"
                }, _toDisplayString(_unref(t)("analytics.reports.remove_report")), 9, _hoisted_3),
                _createVNode(MainButton, {
                  label: _unref(t)('buttons.save'),
                  type: "button",
                  color: "yellow",
                  style: { margin: 0 },
                  onClick: handleUpdateClick,
                  isDisabled: _unref(isReportUpdating)
                }, {
                  default: _withCtx(() => [
                    (_unref(isReportUpdating))
                      ? (_openBlock(), _createBlock(LoadingSpinner, {
                          key: 0,
                          size: "w-5 h-5 mr-2"
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }, 8, ["label", "isDisabled"])
              ])
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createVNode(LoadingSpinner)
            ]))
      ])
    ]),
    _: 1
  }))
}
}

})